import * as echarts from 'echarts';
import React from "react";


export const PieChart = ({ data }: any) => {
    const chartRef = React.useRef(null);

    React.useEffect(() => {
        const chart = echarts.init(chartRef.current);
        const option = {
            // title: {
            //     text: '',
            //     left: 'left'
            // },
            tooltip: {
                trigger: 'item',
            },
            legend: {
                orient: 'vertical',
                left: '85%' // Adjusted to move the legend further to the right
            },
            series: [
                {
                    name: 'Alerts',
                    type: 'pie',
                    radius: '50%',
                    data: [
                        { value: data.noAlerts, name: 'No Alerts', itemStyle: { color: 'green' } },
                        { value: data.L0, name: 'L0+ Alerts', itemStyle: { color: 'red' } },
                        { value: data.L1, name: 'L1+ Alerts', itemStyle: { color: 'yellow' } },
                        { value: data.L2, name: 'L2+ Alerts', itemStyle: { color: 'blue' } },
                    ],
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        };
        chart.setOption(option);
    }, [data]);

    return <div ref={chartRef} style={{ width: '100%', height: '100%' }} />;
};